module.exports = __webpack_public_path__ + "bg-shorten-desktop.svg?a82de60e4b42d5b6b6abf66a03a2dca1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-shorten-desktop.svg
// module id = 18
// module chunks = 0